var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools-legend"},[(_vm.legendItems)?_c('CalendarLegend',{attrs:{"items":_vm.legendItems}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }